<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Forward</v-card-title>

        <v-card-text>

            <v-select
                label="Phone Number"
                v-model="customer_endpoint"
                item-value="endpoint"
                :items="customers"
                v-on:change="onChangePhoneNumber"
            />

            <v-text-field
                label="Name"
                v-model="customer_name"
                autocomplete="off"
            />

            <v-select
                label="Forward To"
                :items="inboxes"
                v-model="inbox_id"
            />

            <v-textarea
                label="Message"
                v-model="message"
            />

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            conversation_id: null,
            inboxes: [],
            customers: [],

            inbox_id: null,
            customer_endpoint: null,
            customer_name: null,
            message: null,
            organization_id: null,
        }
    },

    methods: {

        showDialog(conversation_id)
        {
            this.conversation_id = conversation_id;
            this.inboxes = [];
            this.customers = [];

            this.inbox_id = null;
            this.customer_endpoint = null;
            this.customer_name = null;
            this.message = null;

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'GET-PROFILE: /api/v1/inboxes/start-forward/:conversation_id',
            
                {
                    'conversation_id' : conversation_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.inboxes = data.inboxes;
                    this.customers = data.customers;
                    this.organization_id = data.organization_id;

                    if ( data.customers.length > 0 )
                    {
                        this.customer_endpoint = data.customers[0].endpoint;
                        this.customer_name = data.customers[0].name;
                    }

                    if ( data.inboxes.length > 0 )
                    {
                        this.inbox_id = data.inboxes[0].value;
                    }

                    this.dialog = true;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onChangePhoneNumber()
        {
            for ( let i = 0; i < this.customers.length; i++ )
            {
                if ( this.customers[i].endpoint == this.customer_endpoint && this.customers[i].name.length > 0 )
                {
                    this.customer_name = this.customers[i].name;
                }
            }
        },

        onOk()
        {
            this.dialog = false;

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'MANUALLY-FORWARD-CONTACT-REQUEST: /api/v1/inboxes/start-forward',
            
                {
                    'organization_id' : this.organization_id,
                    'conversation_id' : this.conversation_id,
                    'inbox_id': this.inbox_id,
                    'customer_name' : this.customer_name,
                    'customer_endpoint': this.customer_endpoint,
                    'message' : this.message,
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onCancel()
        {
            this.dialog = false;
        },

    },

    computed: {
        is_valid() 
        {
            if ( this.customer_endpoint == null ) return false;
            if ( this.customer_name == null || this.customer_name.trim().length == 0 ) return false;
            if ( this.message == null || this.message.trim().length == 0 ) return false;

            return true;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>